import { mapGetters } from 'vuex'

export default () => {
  return {
    template: '#template__panelnav',
    computed: {
      ...mapGetters({
        panels: 'panels/items',
        active: 'panels/active',
        previous: 'panels/previous',
        isfirstactive: 'panels/isfirstactive',
        islastactive: 'panels/islastactive',
        panelnavtheme: 'panels/navtheme',
        scrollprogress: 'viewport/progress',
        viewheight: 'viewport/height'
      }),
      scrollposition () {
        return this.scrollprogress.progress
      },
      theme () {
        return this.panelnavtheme && this.panelnavtheme === 'light' ? 'dark' : 'light'
      },
      canshowtitle () {
        let inpos = this.viewheight - this.viewheight / 8
        return this.scrollposition < inpos
      }
    },
    methods: {
      isactive (id) {
        return this.active === id
      },
      isprevious (id) {
        return this.previous === id
      },
      setactive (id) {
        this.$store.dispatch('panels/scrolltopanel', id)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/panelnav.js